import script from "./dateModalYear.vue?vue&type=script&setup=true&lang=js"
export * from "./dateModalYear.vue?vue&type=script&setup=true&lang=js"

import "./dateModalYear.vue?vue&type=style&index=0&id=39332aac&lang=css"

const __exports__ = script;

export default __exports__